import { TableViewStore, BaseListViewStore } from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { ProcedureCodeService} from 'application/product/services';
import {resolveColumns} from 'application/facility/util/resolveColumns';
import _ from 'lodash';
import { action, observable } from 'mobx';

@applicationContext
class ProcedureCodeListViewStore extends BaseListViewStore {
    @observable accessor downloadUrl = null;
    constructor(rootStore) {
        const procedureCodeService = new ProcedureCodeService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'procedure-code',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.procedure-code.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i => 
                        i.id === item.id, 
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.procedure-code.edit',
                        { id: item.id }
                    )
                },
                upload: () => this.rootStore.routerStore.goTo(
                    'master.app.main.procedure-code.upload'
                ),
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await procedureCodeService.find(params);
                        this.onFindSuccess();
                        return response.data;
                    },
                    delete: async (item) => {
                        await procedureCodeService.delete(item);
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'PROCEDURE_CODE.LIST.COLUMNS.NAME',
                    width:'170',
                    onClick: item => this.routes.edit(item)
                },
                {
                    key: 'description',
                    title: 'PROCEDURE_CODE.LIST.COLUMNS.DESCRIPTION',
                    onClick: item => this.routes.edit(item)
                }
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onDelete: async (item) => this.deleteResource(item)
            }
        }));
        this.procedureCodeService = procedureCodeService;
    }

    @action.bound
    async deleteResource(item) {
		const { modalStore, notificationStore } = this.rootStore;

		modalStore.showConfirm(
			'PROCEDURE_CODE.DELETE.MESSAGE',
			async () => {
				try {
					await this.actions.delete(item);
					notificationStore.success('PROCEDURE_CODE.DELETE.SUCCESS');
					await this.queryUtility.fetch();
				} catch (err) {
					notificationStore.error('PROCEDURE_CODE.DELETE.ERROR', err);
				}
			}
		);
	}

    @action.bound
    onFindSuccess() {
        const parameters = this.queryUtility.plainFilter;
        parameters.sort = "name|asc";
        this.downloadUrl =  `${this.procedureCodeService.getDownloadUrl(parameters)}&contentDisposition=attachment&token=${
            this.rootStore.authStore.token.tokenUrl
        }&ttype=${
            this.rootStore.authStore.token.type}`
    }
}

export default ProcedureCodeListViewStore;
